import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import Button from '@dojo/widgets/button';
import NumericEntryBase from './ne-base';
import css from '../css/numeric-entry.m.css';
let NEQuestionAudit = class NEQuestionAudit extends NumericEntryBase {
    onChange(value) {
    }
    update_result() {
        return Promise.resolve();
    }
    submitted() {
        this.invalidate();
    }
    nls_text() {
        const { localizedBundle: { messages: { previous_question: previousText = '', next_question: nextText = '', review: reviewText = '', loading: loadingText = '', correct: correctText = '', incorrect: incorrectText = '', rationale: rationaleText = '', for_more_information: fmiText = '' } } } = this.properties;
        return {
            previousText,
            nextText,
            reviewText,
            loadingText,
            correctText,
            incorrectText,
            rationaleText,
            fmiText
        };
    }
    render_buttons(which) {
        const { previousText, nextText, reviewText, loadingText } = this.nls_text();
        const { onNextQuestion, onPreviousQuestion = () => undefined, hasNextQuestion = () => false, hasPreviousQuestion = () => false, onReview, loaded } = this.properties;
        const buttons = [
            v('div', { classes: [this.theme(css.oneaction)] }, [
                w(Button, {
                    key: 'previous',
                    disabled: !hasPreviousQuestion(),
                    onClick: () => {
                        onPreviousQuestion();
                    }
                }, [previousText])
            ]),
            v('div', { classes: [this.theme(css.oneaction)] }, [
                w(Button, {
                    key: 'next',
                    disabled: !hasNextQuestion(),
                    onClick: () => {
                        onNextQuestion();
                    }
                }, [nextText])
            ]),
            v('div', { classes: [this.theme(css.oneaction)] }, [
                w(Button, {
                    key: 'review',
                    disabled: !loaded,
                    onClick: () => {
                        onReview(true);
                    }
                }, [loaded ? reviewText : loadingText])
            ])
        ];
        return buttons;
    }
    get_numberofquestions() {
        const { quizstore } = this.properties;
        const { get, path } = quizstore;
        const info = get(path('info'));
        return info.lastresult.numberofquestions;
    }
    render() {
        return this.render_feedback();
    }
};
NEQuestionAudit = __decorate([
    theme(css)
], NEQuestionAudit);
export { NEQuestionAudit };
export default NEQuestionAudit;
